/* tslint:disable */
import { NgModule, ModuleWithProviders } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationInterface } from './api-configuration';

import { FilingService } from './services/filing.service';
import { FilingRecordsService } from './services/filing-records.service';
import { AsReportedIssuerService } from './services/as-reported-issuer.service';
import { TradingPlanService } from './services/trading-plan.service';
import { AsReportedSecurityBreakdownService } from './services/as-reported-security-breakdown.service';
import { IssuerMappingService } from './services/issuer-mapping.service';
import { InsiderMappingService } from './services/insider-mapping.service';
import { SecurityMappingService } from './services/security-mapping.service';
import { InsiderRelationshipMappingService } from './services/insider-relationship-mapping.service';
import { QualityGateService } from './services/quality-gate.service';
import { AlertQualityGateService } from './services/alert-quality-gate.service';
import { InsiderTradingPlansService } from './services/insider-trading-plans.service';
import { IssuerTradingPlansService } from './services/issuer-trading-plans.service';
import { InsidersByIssuerService } from './services/insiders-by-issuer.service';
import { InsiderViewTradingPlansService } from './services/insider-view-trading-plans.service';
import { TradingPlansByIssuerAndInsiderNameService } from './services/trading-plans-by-issuer-and-insider-name.service';
import { ManualFilingService } from './services/manual-filing.service';

/**
 * Provider for all Api services, plus ApiConfiguration
 */
@NgModule({
  imports: [
    HttpClientModule
  ],
  exports: [
    HttpClientModule
  ],
  declarations: [],
  providers: [
    ApiConfiguration,
    FilingService,
    FilingRecordsService,
    AsReportedIssuerService,
    TradingPlanService,
    AsReportedSecurityBreakdownService,
    IssuerMappingService,
    InsiderMappingService,
    SecurityMappingService,
    InsiderRelationshipMappingService,
    QualityGateService,
    AlertQualityGateService,
    InsiderTradingPlansService,
    IssuerTradingPlansService,
    InsidersByIssuerService,
    InsiderViewTradingPlansService,
    TradingPlansByIssuerAndInsiderNameService,
    ManualFilingService
  ],
})
export class ApiModule {
  static forRoot(customParams: ApiConfigurationInterface): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: {rootUrl: customParams.rootUrl}
        }
      ]
    }
  }
}
